<template>
  <div class="app-container">
   
    <el-card class="box-card mt10">
      <!-- <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加</el-button>
        </div>
      </div> -->
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="平台名字" prop="platformName" align="center" />
        <el-table-column label="支付方式 " prop="name" align="center" />
        <el-table-column label="是否开启微信直接支付" prop="isOpenMerchant" align="center">
          <!--可用的支付方式（配置code：paymentMethods），数据接口作了调整  
          isOpenAllinpay   是否开启通联的微信/支付宝支付
          isOpenMerchant   是否开启微信支付-->
          <template slot-scope="{row}" v-if="Number(row.code) === 10">
            <el-switch v-model="row.isOpenMerchant" active-value="1" inactive-value="0" @change="changeSwitch(row,1)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="是否开启微信通商云支付" prop="isOpenAllinpay" align="center">
          <template slot-scope="{row}" v-if="Number(row.code) === 10">
            <el-switch v-model="row.isOpenAllinpay" active-value="1" inactive-value="0" @change="changeSwitch(row,2)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="是否开启平台支付方式" prop="enable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.enable" active-value="1" inactive-value="0" @change="changeSwitch(row,3)"></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center" width="230">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <dubBank-add ref="dubBankAdd" @created="doQueryList({})" :rowItem="rowItem" />
  </div>
</template>

<script>
import dubBankAdd from './add'
import sysDataconstantApi from '@/api/config/sysDataconstant'

export default {
  components: {
    dubBankAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      rowItem: null,
      name: ''
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.name = '';
      this.list = this.oldList
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      if (this.name) {
        const result = this.list.filter(user =>
          user.bankName.includes(this.name)
        );
        this.list = result
      } else {
        this.list = this.oldList
      }
    },
    /**
     * 执行列表查询
     */
    doQueryList() {
      this.listLoading = true
      return sysDataconstantApi.fetchCode({ code: 'paymentMethods' })
        .then(({ data }) => {
          this.rowItem = data;
          this.list = data.content ? JSON.parse(data.content) : []
          this.oldList = JSON.parse(JSON.stringify(this.list))
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    changeSwitch(row, type) {
      // el-switch 的 v-model 已经自动更新了值，不需要手动切换
      // 直接保存更新后的数据
      let params = JSON.parse(JSON.stringify(this.rowItem))
      params.content = JSON.stringify(this.list)
      console.log(params)
      sysDataconstantApi.update(params).then(() => {
        this.$common.showMsg('success', '操作成功')
        return this.doQueryList({ pageNo: 1 })
      }).catch((error) => {
        console.error('更新失败:', error)
        this.$common.showMsg('error', '操作失败，请重试')
        // 如果更新失败，重新加载数据以恢复原值
        this.doQueryList({ pageNo: 1 })
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.dubBankAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(scope) {
      this.$refs.dubBankAdd.handleUpdate(scope)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=3&id=" + row.id);
    }
  }
}
</script>
